import Text from '@sats-group/ui-lib/react/text';
import React from 'react';
import ArrowLinkGroup from '~/client/components/arrow-link-group/arrow-link-group';
import ContentContainer from '~/client/components/content-container/content-container';
import Layout from '~/client/components/layout/layout';
import type { TermsAndConditionsListPage as Props } from './terms-and-conditions-list-page.types';

const TermsAndConditionsListPage: React.FunctionComponent<Props> = ({
  layout,
  links,
  secondaryLinks,
  title,
}) => (
  <Layout {...layout}>
    <ContentContainer>
      <div className="terms-and-conditions-list-page">
        <div className="terms-and-conditions-list-page__group">
          <Text
            elementName="h1"
            size={Text.sizes.headline1}
            theme={Text.themes.headline}
            italic
          >
            {title}
          </Text>
          <ArrowLinkGroup {...links} small />
        </div>
        {secondaryLinks ? (
          <div className="terms-and-conditions-list-page__group">
            <Text
              elementName="h2"
              size={Text.sizes.headline2}
              theme={Text.themes.emphasis}
            >
              {secondaryLinks.title}
            </Text>
            <ArrowLinkGroup {...secondaryLinks.links} small />
          </div>
        ) : null}
      </div>
    </ContentContainer>
  </Layout>
);

export default TermsAndConditionsListPage;
